<template>
    <div class="main-content clearfix">
        <div class="container bg-white" style="min-height: 75vh;">
            <div class="card p-4" v-if="product">
                <div class="card-top">
                    <div class="d-flex flex-row flex-wrap align-items-center justify-content-between mb-3">
                        <nav style="--bs-breadcrumb-divider: url(&#34;data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8'%3E%3Cpath d='M2.5 0L1 1.5 3.5 4 1 6.5 2.5 8l4-4-4-4z' fill='%236c757d'/%3E%3C/svg%3E&#34;);"
                    aria-label="breadcrumb">
                    <ol class="breadcrumb mb-0">
                    <li class="breadcrumb-item">
                    <router-link to="/">All Products
                        <!-- <img src="assets/images/home-icon.svg" alt="" /> -->
                    </router-link> 
                    </li>
                    <li class="breadcrumb-item" aria-current="page" v-for="(item, x) in product.breadcum"
                    :key="'br' + x">
                    <router-link :to="'/category/' + item.slug_url
                        ">{{ item.name }}</router-link>

                    </li> 
                    <li  class="breadcrumb-item active"  v-if="sku" aria-current="page">{{sku}}</li>
                    </ol>

                    </nav>

                        <!-- <div class="pro-item">
                            <h6 class="m-0 font-400 font-14">Item # bci 1738978</h6>
                        </div> -->
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 col-lg-6 col-xl-6">
                        <div class="slider-brand-logo">
                            <a href="javascript:void(0);"
                                v-if="product.product.vendor && product.product.vendor.shop_profile">
                                <img :src="set_image(product.product.vendor.shop_profile.business_logo)"
                                    :alt="product.product.vendor.shop_profile.company_name" width="150" height="150">
                            </a>
                        </div>
                        <!-- Product Slider Start -->
                        <div class="product-images">
                            <!-- Main Slider Start -->
                            <div class="product-main-slider">

                                <VueSlickCarouselFinal :lazyLoad="'ondemand'" :slidesToShow=1 :slidesToScroll=1
                                    :autoplay="true" :arrows="false" :fade="false" :infinite="true" ref="c1" :asNavFor="c2"
                                    @beforeChange="syncSliders">
                                    <div v-for="(mainImage, index)  in product.product.galleries" :key="index">
                                        <div class="pro-main-item">
                                            <img :src="set_image(mainImage.name)" alt="">
                                        </div>
                                    </div>

                                </VueSlickCarouselFinal>

                            </div>
                            <!-- Main Slider End -->

                            <!-- Thumbnail Slider Start -->
                            <div class="product-nav-slider">
                                <VueSlickCarouselFinal :lazyLoad="'ondemand'" :slidesToShow=4 :slidesToScroll=1
                                    :autoplay="true" :infinite="true" :dots="false" :arrows="true" :focusOnSelect="true"
                                    :vertical="true" :verticalSwiping="true" ref="c2" :asNavFor="c1" :responsive="[
                                        {
                                            breakpoint: 1199,
                                            settings: {
                                                vertical: false,
                                                verticalSwiping: false,
                                                slidesToShow: 3,
                                            },
                                        },
                                        {
                                            breakpoint: 767,
                                            settings: {
                                                vertical: false,
                                                verticalSwiping: false,
                                                slidesToShow: 3,
                                            },
                                        },
                                    ]" @beforeChange="syncSliders">

                                    <div v-for="(thumbnailImage, index)  in product.product.galleries" :key="index">
                                        <div class="pro-thumbnail-item">
                                            <img :src="set_image(thumbnailImage.name)" alt="">
                                        </div>
                                    </div>

                                </VueSlickCarouselFinal>

                            </div>
                            <!-- Thumbnail Slider End -->
                        </div>
                        <!-- Product Slider End -->
                    </div>
                    <div class="col-md-12 col-lg-6 col-xl-6">
                        <!-- Product Information Start -->
                        <div class="product-information">
                            <h4 class="font-300 product-full-title">{{ name }}</h4>
                            <h6 class="product-model">Brand:<span class="ms-1">{{ description }}</span></h6>
                            <h6 class="product-model">SKU:<span class="ms-1">{{ sku }}</span></h6>
                          
                            <div class="product-price mb-3">
                                <ProductPriceElement
                                    :pPrice="Number(sell_price(product.price, product.discount, product.product_admin_markup_amount, product.contractor_products[0].markup, product.box_sqft, (product.product && product.product.category && product.product.category.unit) ? product.product && product.product.category && product.product.category.unit : ''))"
                                    :category="product.product.category"
                                    :sizeSet="{ width_size: product.width_size, height_size: product.height_size, minimum_unit: product.minimum_unit, box_sqft: product.box_sqft, unit: product.unit }" />

                            </div>
                            <div class="product-color">
                                <ul class="list-unstyled">
                                    <li :class="product.id == linkProduct.sizes[0].id ? 'active' : ''"
                                        v-for="(linkProduct, index) in link_products" v-if="link_products" :key="index">
                                        <router-link :to="'/product/' + str_encode(linkProduct.sizes[0].id)">
                                            <img :src="set_image(linkProduct.photo)" :alt="linkProduct.name">
                                        </router-link>
                                    </li>

                                </ul>
                            </div>
                            <div class="product-delivery mt-2 mt-md-4">
                                <h6 class="mb-0 text-purple delivery-day" v-if="showroomId && showroomId.basic_addon"> FREE Shipping / Pickup</h6>
                            </div>

                            <div class="project-size mt-4 mb-3 d-none" v-if="product.product.category.unit == 'Box'">
                                <form class="row align-items-center gx-3">
                                    <div class="col-md-6 col-lg-6">
                                        <div class="feet-counter">
                                            <label class="font-500 mb-2">Size of your project</label>
                                            <input type="text" class="form-control" v-model="sizeProject"
                                                placeholder="Enter Sqft">
                                        </div>
                                    </div>
                                </form>
                            </div>

                            <div class="product-shopping mb-3 mt-2">
                                <div class="card p-2">
                                    <div class="product-quantity">
                                        <button class="btn btn-decrement" @click.prevent="decrementQty">-</button>
                                        <input class="form-control quantity-num" v-model="quantity" type="number" min="1"
                                            id="quantity" />
                                        <button class="btn btn-increment" @click.prevent="incrementQty">+</button>
                                    </div>
                                    <div class="add-cart flex-row">
                                        <button type="button" class="btn btn-primary  justify-content-between"
                                            @click.prevent="sync_cart(product)">
                                            <div> Add to Cart</div>
                                            <div><b>{{
                                                itemPrice > 0 ? itemPrice : sell_price(product.price, product.discount,
                                                    product.product_admin_markup_amount,
                                                    product.contractor_products[0].markup, product.box_sqft,
                                                    (product.product && product.product.category &&
                                                        product.product.category.unit) ? product.product &&
                                                        product.product.category && product.product.category.unit : '') |
                                            toCurrency
                                            }}</b></div>
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div class="d-block d-md-flex align-items-center justify-content-between mt-2">
                               
                                <button class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#freeSample" v-if="product.product.category.is_sample">Request
                                    Free Sample</button>
                                <div class="product-return ms-md-2">
                                    <router-link to="/return_policy">Return & Shipping Details</router-link>
                                </div>
                            </div>
                        </div>
                        <!-- Product Information End -->


                        <form class="card p-2 mt-3 productCalculator" v-if="product && product.product && product.product.category && product.product.category.unit == 'Box'">
                            <div class="pb-2">
                                <div class="row">
                                    <div class="col-6 col-md-6 col-lg-6">
                                        <div class="form-group mb-3">
                                            <label class="form-label">Length</label>
                                            <input type="text" class="form-control" v-model="length"
                                                @keyup.prevent="getBoxs" placeholder="Enter ft">
                                        </div>
                                    </div>
                                    <div class="col-6 col-md-6 col-lg-6">
                                        <div class="form-group mb-3">
                                            <label class="form-label">Width</label>
                                            <input type="text" class="form-control" v-model="width" @keyup.prevent="getBoxs"
                                                placeholder="Enter ft">
                                        </div>
                                    </div>
                                    <div class="col-6 col-md-6 col-lg-6">
                                        <div class="form-group mb-3">
                                            <label class="form-label">Enter Project SQFT</label>
                                            <input type="text" class="form-control" v-model="size_sqft"
                                                @keyup.prevent="getBoxs('sqft')" placeholder="Enter Project SQFT">
                                        </div>
                                    </div>
                                    <div class="col-6 col-md-8 col-lg-8">
                                        <div class="text-center">
                                            <p>Size of your project: {{ this.sizeProject }} sqft</p>
                                        </div>
                                    </div>
                                    <div class="col-6 col-md-4 col-lg-4">
                                        <div class="text-center">
                                            <label class="font-600">
                                                {{ tot_boxes }} boxes</label>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <button type="button" class="btn btn-primary w-100" @click.prevent="useAmount"
                                            data-bs-dismiss="modal" aria-label="Close">Use Amount
                                        </button>
                                    </div>
                                </div>
                            </div>

                        </form>



                    </div>
                </div>


                <div class="modal fade" id="freeSample" tabindex="-1" role="dialog" aria-labelledby="freeSampleLabel"
                    aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered" role="document" style="max-width: 1200px;">
                        <div class="modal-content">
                            <div class="cs-modal">
                                <button type="button" class="btn btn-close" data-bs-dismiss="modal"
                                    aria-label="Close"></button>
                                <div class="modal-lft" style="background: url(assets/images/free-sample.jpg);">
                                </div>
                                <div class="modal-rgt bg-white">
                                    <p class="mb-3">Fill out the form below, and our team will reach out to you shortly.</p>
                                    <form @submit.prevent="submit_sample_request()">

                                        <div class="row">
                                            <div class="col-lg-6 col-md-6 col-sm-12">
                                                <input type="text" v-model="form.first_name" placeholder="First Name"
                                                    class="form-control" v-validate="'required'" name="first_name">
                                                <p class="errormsg" v-if="verrors.has('first_name')">
                                                    {{ verrors.first('first_name') }}
                                                </p>
                                            </div>
                                            <div class="col-lg-6 col-md-6 col-sm-12">
                                                <input type="text" v-model="form.last_name" placeholder="Last Name"
                                                    class="form-control" name="last_name">
                                            </div>
                                            <div class="col-lg-12">
                                                <input type="email" v-model="form.email" placeholder="Email"
                                                    class="form-control" v-validate="'required|email'" data-vv-as="Email"
                                                    name="email">
                                                <p class="errormsg" v-if="verrors.has('email')">
                                                    {{ verrors.first('email') }}
                                                </p>
                                            </div>
                                            <div class="col-lg-12">
                                                <input type="text" v-model="form.phone" placeholder="Phone Number"
                                                    class="form-control">
                                            </div>
                                            <div class="col-lg-12">
                                                <input type="text" v-model="form.address" placeholder="Address"
                                                    class="form-control">
                                            </div>
                                            <div class="col-lg-6 col-sm-12">
                                                <input type="text" v-model="form.state" placeholder="State"
                                                    class="form-control">
                                            </div>
                                            <div class="col-lg-6 col-sm-12">
                                                <input type="text" v-model="form.zipcode" placeholder="ZipCode"
                                                    class="form-control">
                                            </div>
                                            <div class="col-lg-12 text-center">
                                                <button type="submit" class="btn btn-primary">Submit</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Also Viewed Section Start -->

                <CustomerViewed :CustomerView="CustomerView"></CustomerViewed>

                <!-- Also Viewed Section End -->

                <div class="card product-full-detail p-4 mt-5">
                    <h3 class="border-bottom border-1 pb-3 mb-4">Product Details</h3>
                    <div class="row">
                        <div class="col-md-6 col-lg-6" v-for=" (section, index) in product.section_inputs" :key="index">
                            <h4 class="detail-title mb-3">{{ section.name }}</h4>
                            <div class="table-responsive mb-3">
                                <table class="table table-striped table-borderless table-bordered measurements-table">
                                    <tbody>
                                        <tr v-for="(inputValue, index) in section.section_inputs" :key="index">
                                            <td class="measurements-title">{{ inputValue.name }}</td>
                                            <td class="dimension">{{ inputValue.input_value }}</td>
                                        </tr>

                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>


                    <div class="card p-3">
                        <h4 class="detail-title mb-3">Product Overview:</h4>
                        <p v-html="product.product.product_overview"></p>
                    </div>
                </div>
            </div>

            <!-- Recently Viewed  Section Start -->

            <RecentlyViewed :recentlyViewed="RecentlyViewed"></RecentlyViewed>
          
        </div>
        <div ref="myModel" class="modal feet-counter-modal fade" id="FeetCounterModal" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h3 class="modal-title fs-5" id="exampleModalLabel"> Calculate my square footage </h3>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <form>
                            <div class="border-bottom-1 mb-3 pb-3">
                                <div class="row">
                                    <div class="col-6 col-md-6 col-lg-6">
                                        <div class="form-group mb-3">
                                            <label class="form-label">Length</label>
                                            <input type="text" class="form-control" v-model="length"
                                                @keyup.prevent="getBoxs" placeholder="Enter ft">
                                        </div>
                                    </div>
                                    <div class="col-6 col-md-6 col-lg-6">
                                        <div class="form-group mb-3">
                                            <label class="form-label">Width</label>
                                            <input type="text" class="form-control" v-model="width" @keyup.prevent="getBoxs"
                                                placeholder="Enter ft">
                                        </div>
                                    </div>
                                    <div class="col-6 col-md-6 col-lg-6">
                                        <div class="form-group mb-3">
                                            <label class="form-label">Enter Project SQFT</label>
                                            <input type="text" class="form-control" v-model="size_sqft"
                                                @keyup.prevent="getBoxs('sqft')" placeholder="Enter Project SQFT">
                                        </div>
                                    </div>
                                    <div class="col-6 col-md-8 col-lg-8">
                                        <div class="text-center">
                                            <p>Size of your project: {{ this.sizeProject }} sqft</p>
                                        </div>
                                    </div>
                                    <div class="col-6 col-md-4 col-lg-4">
                                        <div class="text-center">
                                            <label class="font-600">
                                                {{ tot_boxes }} boxes</label>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <button type="button" class="btn btn-primary w-100" @click.prevent="useAmount"
                                            data-bs-dismiss="modal" aria-label="Close">Use Amount
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <h5>Size of your project</h5>
                            <div class="row align-items-center mb-3">
                                <div class="col-6 col-md-4 col-lg-4">
                                    <div class="form-group mb-0">
                                        <input type="text" class="form-control" placeholder="0.00" readonly>
                                    </div>
                                </div>
                                <div class="col-6 col-md-8 col-lg-8">
                                    <label class="form-label font-500 m-0">Number of boxes </label>
                                </div>
                            </div>

                            <h5>Quantity of boxes</h5>
                            <div class="row align-items-center mb-3">
                                <div class="col-6 col-md-4 col-lg-4">
                                    <div class="form-group mb-0">
                                        <div class="product-quantity">
                                            <button class="btn btn-decrement" @click.prevent="decrementQty" id="decrement"
                                                :disabled="this.quantity < 1">-
                                            </button>
                                            <input class="form-control quantity-num" v-model="quantity" type="number"
                                                min="1" />
                                            <button class="btn btn-increment" @click.prevent="incrementQty" id="increment">+
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-6 col-md-8 col-lg-8">
                                    <label class="form-label m-0 font-500">{{ sell_price(product.price, product.discount,
                                        product.product_admin_markup_amount, product.contractor_products[0].markup,
                                        product.box_sqft, (product.product && product.product.category &&
                                            product.product.category.unit) ? product.product && product.product.category &&
                                    product.product.category.unit : '') | toCurrency }}/
                                        box</label>
                                </div>
                            </div>

                            <div class="text-center">
                                <p class="font-13 m-0">1 box = {{ product.box_sqft }}
                                    |{{ sell_price(product.price, product.discount, product.product_admin_markup_amount,
                                        product.contractor_products[0].markup, product.box_sqft, (product.product &&
                                            product.product.category && product.product.category.unit) ? product.product &&
                                            product.product.category && product.product.category.unit : '') | toCurrency }}</p>
                                <h3 class="m-0">Total:
                                    {{ itemPrice > 0 ? itemPrice : sell_price(product.price, product.discount,
                                        product.product_admin_markup_amount, product.contractor_products[0].markup,
                                        product.box_sqft, (product.product && product.product.category &&
                                            product.product.category.unit) ? product.product && product.product.category &&
                                    product.product.category.unit : '') | toCurrency }} </h3>
                            </div>
                        </form>
                    </div>
                    <!-- <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                        <button type="button" class="btn btn-primary">Save changes</button>
                    </div> -->
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
//import VueSlickCarouselFinal from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";

import Loading from "../components/Loading";
import { EventBus } from '../store/eventBus';


const Breadcrumb = () => ({
    component: import('../components/Breadcrumb.vue'),
    loading: Loading,
})


const VueSlickCarouselFinal = () => ({
    component: import('vue-slick-carousel'),
    loading: Loading,
})

const CustomerViewed = () => ({
    component: import('../components/CustomerViewed.vue'),
    loading: Loading,
})

const RecentlyViewed = () => ({
    component: import('../components/RecentlyViewed.vue'),
    loading: Loading,
})



export default {
    metaInfo() {
    return {
        title: this.meta.page_title +' | ' + appname,
        meta: [
        {
            vmid: 'description',
            name: 'description',
            content: this.meta.description
        },
        {
            vmid: 'canonical',
            rel: 'canonical',
            href: this.meta.currentUrl
        },
        {
            vmid: 'og:title',
            property: 'og:title',
            content: this.meta.page_title +' | ' + appname
        },
        {
            vmid: 'og:description',
            property: 'og:description',
            content: this.meta.description
        },
        {
            vmid: 'twitter:title',
            property: 'twitter:title',
            content: this.meta.page_title +' | ' + appname
        },
        {
            vmid: 'twitter:description',
            property: 'twitter:description',
            content: this.meta.description
        },
        {
            vmid: 'twitter:image',
            property: 'twitter:image',
            content: this.meta.image
        },
        {
            vmid: 'keywords',
            property: 'keywords',
            content: this.meta.keywords
        },
        ]
    };
    },

    components: {
        VueSlickCarouselFinal,
        Breadcrumb,
        CustomerViewed,
        RecentlyViewed
    },

    data() {
        return {
            meta:{
                page_title:'Product',
                description:'Product ' + appname,
                keywords:'Product ' + appname,
                currentUrl: window.location.origin + this.$route.fullPath,
                image:''
            },
            form: {},
            product: [],
            c1: undefined,
            c2: undefined,
            myModel: undefined,
            name: '',
            prince: '',
            sku: '',
            description: '',
            currentSelectedLinkItem: '',
            galleries: {},
            link_products: [],
            quantity: 1,
            itemPrice: 0,
            length: '',
            width: '',
            size_sqft: '',
            sizeProject: 0,
            tot_boxes: 0,

        }
    },


    computed: {
        ...mapGetters({
            showroomId: 'Common/MyItem',
            Bre: 'Common/Breadcrumb',
            CustomerView: 'Common/CustomerViewed',
            RecentlyViewed: 'Common/RecentlyViewed'
        }),
        ...mapGetters(["errors"]),

    },

    created() {
        //   this.get_product();

    },

    mounted() {
        this.c1 = this.$refs.c1;
        this.c2 = this.$refs.c2;
        if(!this.$route.params.vsd_id){
         //   history.pushState({}, "", this.$route.path+'/'+this.showroomId.vsd_id);
        } 
 
       
    },
    watch: {
        "$route.params.hash": {
            handler: function (value) {
                this.get_product();
            },
            deep: true,
            immediate: true,
        },
        quantity(n){
            let parsedInput = Number(n);
            if (isNaN(parsedInput) || parsedInput < 1){
                this.quantity=1; 
            }
            this.itemPrice = this.getSellPrice() * this.quantity
        }
    },
    methods: {

        ...mapActions('Common', ['updateBreadcrumb']),
        ...mapActions('cart', ['addCartRequest']),
        ...mapActions('Common',['updateMyItem' ]),

        get_product() {
            let id = this.str_decode(this.$route.params.hash)
            this.currentSelectedLinkItem = id
            let cId= this.showroomId.showroom
            if(shop_id){
                let a= shop_id
                cId=a.split('-')[0].match(/\d+/)[0]; 
                this.updateMyItem({
                showroom: cId,
                vsd_id:a,
                basic_addon:this.showroomId.basic_addon,
                custom_addon:this.showroomId.custom_addon, 
                theme_color:this.showroomId.theme_color
            });
            }

            this.getSingleProduct(id, cId).then((res) => {
                //  pageLoader.hide();

                if (res.data.data) {
                    this.updateBreadcrumb({
                        'parent': this.Bre.parent,
                        'child': this.Bre.child,
                        'product': res.data.data.product.sku !== null ? res.data.data.product.sku : res.data.data.product.description
                    })
                    this.product = res.data.data
                    this.name = res.data.data.product.name
                    this.sku = res.data.data.product.sku
                    this.prince = res.data.data.product.price
                    this.description = res.data.data.product.description
                    this.galleries = res.data.data.product.galleries
                    this.link_products = res.data.data.product.link_products

                    if(this.product){
                        this.meta.page_title = this.name || 'Product';
                        this.meta.currentUrl = window.location.href
                        this.meta.description = this.name|| 'Product';
                        this.meta.keywords = this.sku + ' , '+ this.name;
                        this.meta.image = this.set_image(this.product.product.photo) ;                         
                    }


                } else {
                    Toast.fire({
                        icon: 'warning',
                        title: 'No Product Found.'
                    });
                    this.$router.push('/404').catch(() => {
                    });
                    ;
                }

            }).catch((error) => {

            })
        },

        CalculateProductSellPrice(Price, Discount, ProductAdminMarkupAmount, ContractorMarkup, box_sqft = 0, unit = '') {
            let sell_price = this.sell_price(Price, Discount, ProductAdminMarkupAmount, ContractorMarkup, box_sqft, unit);
            this.itemPrice = unit == 'Box' ? (sell_price / box_sqft) : sell_price
            return unit == 'Box' ? (sell_price / box_sqft) : sell_price;
        },

        sell_price(Price, Discount, ProductAdminMarkupAmount, ContractorMarkup, box_sqft = 0, unit = '') {
            Price = parseFloat(Price);
            Discount = parseFloat(Discount);
            ProductAdminMarkupAmount = parseFloat(ProductAdminMarkupAmount);
            ContractorMarkup = parseFloat(ContractorMarkup);
            let product_price = (Price - (Price * Discount / 100)) + ProductAdminMarkupAmount;
            let contractor_markup = product_price * ContractorMarkup / 100;
            //let admin_markup = ProductAdminMarkupAmount
            let sell_price = product_price + contractor_markup;
            return sell_price;
        },
        syncSliders(currentPosition, nextPosition) {
            this.$refs.c1.next()
            this.$refs.c2.next()
        },
        getLinkProduct(linkProduct) {
            this.name = linkProduct.name;
            this.prince = linkProduct.price
            this.sku = linkProduct.sku
            this.description = linkProduct.description
            this.currentSelectedLinkItem = linkProduct.id
        },
        incrementQty() {
            this.quantity = this.quantity + 1
            this.itemPrice = this.getSellPrice() * this.quantity
        },
        decrementQty() {

            if (this.quantity >= 1) {
                this.quantity = this.quantity > 1 ? this.quantity - 1 : 1
                this.itemPrice = this.getSellPrice() * this.quantity
            }

        },
        getBoxs(en = '') {
            if (this.length > 0 && this.width > 0) {
                this.sizeProject = this.length * this.width
            }
            if (en == 'sqft') {
                this.sizeProject = this.size_sqft
                this.length = this.width = ''
            } else {
                this.size_sqft = ''
            }
            if (this.product.product.category.unit == 'Box') {
                let roomsqft = this.sizeProject
                let box_sqft = this.product.box_sqft
                let minimum_unit = this.product.minimum_unit
                let bx = Math.ceil(roomsqft / box_sqft)
                this.tot_boxes = bx < minimum_unit ? minimum_unit : bx
            }
        },
        getSellPrice() {
            let sellerPrice = this.sell_price(this.product.price,
                this.product.discount,
                this.product.product_admin_markup_amount,
                this.product.contractor_products[0].markup,
                this.product.box_sqft,
                (this.product.product && this.product.product.category && this.product.product.category.unit) ? this.product.product &&
                    this.product.product.category && this.product.product.category.unit : '')

            return sellerPrice
        },

        useAmount() {
            // this.$refs.myModel.hide()

            this.quantity = Number(this.tot_boxes)


            this.itemPrice = this.getSellPrice() * this.quantity

        },
        beforeOpenPop() {
            this.quantity = 1
            this.width = ""
            this.length = ""
            this.sizeProject = ""
            this.size_sqft = ""
        },
        generateUniqueSixDigitNumber() {
            let uniqueNumber = '';
            const existingNumbers = new Set();

            while (uniqueNumber.length !== 6) {
                uniqueNumber = Math.floor(100000 + Math.random() * 900000).toString();

                if (!existingNumbers.has(uniqueNumber)) {
                existingNumbers.add(uniqueNumber);
                } else {
                uniqueNumber = ''; // Reset the number if it's not unique
                }
            }

            return uniqueNumber;
        },
        sync_cart(item) {
            let cart_item = {}
            cart_item.id = item.id
            cart_item.qty = this.quantity
            cart_item.price = item.price
            cart_item.final_price = item.final_price*this.quantity
            cart_item.item=item

            // var project = parseInt(localStorage.getItem('project'));
            // cart_item.project_id = project
            // this.addCartRequest(cart_item).then(() => { })




            var project = parseInt(localStorage.getItem('project'));
            console.log("project==========>",project);


            let cart_id="cart-"+this.generateUniqueSixDigitNumber();
                if(!localStorage.getItem('project')){
                    console.log("NaN.............");

            // if(project){
                    if(localStorage.getItem('cart_id')){
                        cart_id=localStorage.getItem('cart_id');
                    }
                    localStorage.setItem("cart_id", cart_id);
                   cart_item.is_cart=true;
                }
                cart_item.project_id = project ? project : cart_id;
                this.addCartRequest(cart_item).then(() => {

                    Swal.fire({
                    title: 'Item Added to Cart!',
                    imageUrl: this.set_image(item.product.photo), 
                    imageWidth: 100,
                    imageHeight: 100,
                    imageAlt: 'Product image',
                    showCancelButton: true,
                    confirmButtonText: 'Checkout Now',
                    cancelButtonText: 'Keep Shopping',
                    confirmButtonColor: '#497f75',
                    cancelButtonColor: '#aaa',
                    reverseButtons: true
                    }).then((result) => {
                    if (result.isConfirmed) {
                        // Redirect to checkout page
                        this.$router.push({ name: 'Cart' });
                    } else if (result.dismiss === Swal.DismissReason.cancel) {
                        // Close the alert and continue shopping
                        console.log('Continue shopping');
                    }
                    });

                    loaderd.hide();
                })
                .catch(() => {
                    loaderd.hide();
                })

            // if(project){
            //     cart_item.project_id = project
            //     this.addCartRequest(cart_item).then(() => {
            //         // loaderd.hide();
            //     })
            //     .catch(() => {
            //         // loaderd.hide();
            //     })
            // }
            EventBus.$emit('cart-updated');
        },


        submit_sample_request() {
            this.$validator.validateAll().then(async (valid) => {
                if (valid) {

                    let loader = this.$loading.show({ loader: 'dots' })
                    this.form.product = this.product
                    axios.post('api/sample_request', this.form)
                        .then((data) => {
                            loader.hide()
                            if (data.data.success) {
                                this.form = {};
                                var myModal = bootstrap.Modal.getOrCreateInstance(document.getElementById('freeSample'));
                                myModal.hide();
                            }
                            Toast.fire({
                                icon: 'success',
                                title: data.data.message
                            });
                        })
                        .catch(err => {
                            loader.hide()
                        })

                }
            })
        },
        getReviewSku(review_sku) {
            return review_sku.toString();
        }


    },

}

</script>
